import { APIVersion } from "@lib/telegram";
import { Container, Label, Value } from "./VersionNumber.styles";
import { useTranslation } from "react-i18next";

interface VersionNumberProps {
    /**
     * Custom label text (for Storybook)
     */
    labelText?: string;
    /**
     * Custom value text (for Storybook)
     */
    valueText?: string;
}

const VersionNumber = ({ labelText, valueText }: VersionNumberProps) => {
    const { t } = useTranslation();
    
    return (
        <Container>
            <Label>
                {labelText || t('components.versionNumber.label')}
            </Label>
            <Value>
                {valueText || APIVersion() || t('components.versionNumber.unavailable')}
            </Value>
        </Container>
    );
};

export default VersionNumber;